import '~/globals.js'
import 'lazysizes';
import smartquotes from 'smartquotes';
import slideshow from '~/packs/tlms/slideshow';
import masthead from '~/packs/tlms/masthead';
import searchForm from '~/packs/tlms/search';
import processionList from '~/packs/tlms/procession';
import fadeFlashes from '~/packs/tlms/flashes';
import { balanceHeadings } from '~/packs/tlms/text';
import { activate, addActivation, addListenerActivation, addSelectorActivation } from '~/packs/droom/activate';
import { fetchToc, fetchButtons, fetchOnClick } from '~/packs/tlms/fetches';
import { startLogging, log } from '~/packs/droom/logging';
import { remoteLink, submitFormLink } from '~/packs/droom/helpers';
import { fetchRegisterForm } from '~/packs/droom/registration';
import { zoomOnClick } from '~/packs/droom/zoomer';

/*
  Here we build a collection of activators that will be applied to each new element
  as it is added to the page, and to the whole page when it is first loaded.
  Other activators might be declared by other scripts; all will be applied in order of declaration.
*/

/* Content features */
addSelectorActivation('masthead', '#tlms_nav', masthead);
addSelectorActivation('search', '.search_holder', searchForm);
addSelectorActivation('slideshow', '.cms-slides', slideshow);
addSelectorActivation('procession', '#processional_order', processionList);
addListenerActivation('zoom', '[data-zoomed]', 'click', zoomOnClick);

/* Post-cache content fetches */

addSelectorActivation('toc', 'div.pages[data-content]', fetchToc);
addSelectorActivation('frag', '[data-fragment="takepart"]', fetchRegisterForm);
addSelectorActivation('page_button', '#buttons[data-page]', fetchButtons);
addSelectorActivation('page_collection_button', '#buttons[data-page-collection]', fetchButtons);
addSelectorActivation('replace_me', 'a.replace_me', fetchOnClick);
addSelectorActivation('remote_link', 'a[remote], a[data-remote], a[data-method]', remoteLink);
addSelectorActivation('submit_link', 'a[data-action="submit"]', submitFormLink);

/* Presentation niceties */

addActivation('smartquotes', smartquotes);
addActivation('balance', balanceHeadings);

/* On page load, apply all the activators to the whole document. */

document.addEventListener('DOMContentLoaded', (_) => {
  startLogging(); // unless production...
  log('✅ DOMContentLoaded');
  activate(document);
  fadeFlashes();
});
